var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { useTheme } from "../../../lib/hooks";
import { cn } from "../../../lib/utils";
import { injectGlobal } from '@emotion/css';
import React from 'react';
import { ResultClockDark, ResultClockLight, ResultCountdown, sizeMapWidth } from "./comp";
import * as styles from "./result";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var _styles = injectGlobal(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n@keyframes rotate {\n  0% {\n      transform: rotate(0deg);\n      animation: shake 0.5s ease-in-out infinite alternate;\n  }\n\n  100% {\n      transform: rotate(360deg);\n  }\n}\n.moly-result{\n  font-family: var(--bds-font-family);\n  .moly-result-title {\n    margin-top: 16px;\n  }\n}\n\n.moly-result-image {\n  img {\n    height: 100%;\n  }\n}\n\n.moly-result-large {\n  .moly-btn {\n    min-width: 188px;\n  }\n\n  .moly-result-image {\n    height: 72px;\n  }\n  .moly-result-subtitle{\n    margin-top: 8px;\n  }\n}\n\n.moly-result-medium {\n  .moly-btn {\n    min-width: 130px;\n  }\n  .moly-result-image {\n    height: 64px;\n  }\n  .moly-result-subtitle{\n    margin-top: 4px;\n  }\n}\n\n.moly-result-small {\n  .moly-btn {\n    min-width: 130px;\n  }\n  .moly-result-image {\n    height: 56px;\n  }\n  .moly-result-subtitle {\n    margin-top: 0;\n  }\n}\n"])));
var Result = function Result(_ref) {
  var image = _ref.image,
    imageStyle = _ref.imageStyle,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    title = _ref.title,
    subTitle = _ref.subTitle,
    extra = _ref.extra,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'success' : _ref$status,
    theme = _ref.theme,
    _ref$countdown = _ref.countdown,
    countdown = _ref$countdown === void 0 ? 5 : _ref$countdown;
  var _useTheme = useTheme(),
    _useTheme2 = _slicedToArray(_useTheme, 1),
    color = _useTheme2[0];
  var realTheme = theme || color;
  var width = sizeMapWidth[size] || 72;
  var RESULT_STYLE = {
    light: {
      success: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-a94c1c9e32e74d0696a47a434310a189.svg",
        alt: "success",
        width: width
      }),
      error: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-84f00a214fb54eacbc2ec92086433b3f.svg",
        alt: "error",
        width: width
      }),
      pending: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-ce5dd07f6a53413f825a09b9a5579d99.svg",
        alt: "pending",
        width: width
      }),
      warning: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-88a487697968406faa1aa1918f1287e8.svg",
        alt: "warning",
        width: width
      }),
      clock: /*#__PURE__*/_jsx(ResultClockLight, {
        size: size
      }),
      countdown: /*#__PURE__*/_jsx(ResultCountdown, {
        size: size,
        theme: realTheme,
        time: countdown
      })
    },
    dark: {
      success: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-a94c1c9e32e74d0696a47a434310a189.svg",
        alt: "success",
        width: width
      }),
      error: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-84f00a214fb54eacbc2ec92086433b3f.svg",
        alt: "error",
        width: width
      }),
      pending: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-9ab07951251a4721b61bfc2301466ced.svg",
        alt: "pending",
        width: width
      }),
      warning: /*#__PURE__*/_jsx("img", {
        src: "https://s1.bycsi.com/bybit/deadpool/image-88a487697968406faa1aa1918f1287e8.svg",
        alt: "warning",
        width: width
      }),
      clock: /*#__PURE__*/_jsx(ResultClockDark, {
        size: size
      }),
      countdown: /*#__PURE__*/_jsx(ResultCountdown, {
        size: size,
        theme: realTheme,
        time: countdown
      })
    },
    title: {
      large: styles.molyText18,
      medium: styles.molyText16,
      small: styles.molyText14
    },
    subTitle: {
      large: styles.molyText16,
      medium: styles.molyText14,
      small: styles.molyText12
    },
    extra: {
      large: styles.molyMargin32,
      medium: styles.molyMargin20,
      small: styles.molyMargin16
    }
  };
  var ExceptionStatus = Object.keys(RESULT_STYLE['light']);
  var imageNode = null;
  var des = title || subTitle;
  var alt = typeof des === 'string' ? des : 'result';
  if (typeof image === 'string') {
    imageNode = /*#__PURE__*/_jsx("img", {
      alt: alt,
      src: image
    });
  } else if (image) {
    imageNode = image;
  } else if (ExceptionStatus.includes("".concat(status))) {
    var _RESULT_STYLE;
    var SVGComponent = (_RESULT_STYLE = RESULT_STYLE[realTheme]) === null || _RESULT_STYLE === void 0 ? void 0 : _RESULT_STYLE[status];
    imageNode = SVGComponent;
  } else {
    // 无默认
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    style: style,
    className: cn(className, styles.molyResult, "moly-result-".concat(size), "moly-result-".concat(realTheme), 'moly-result'),
    children: [/*#__PURE__*/_jsx("div", {
      className: cn("moly-result-image"),
      style: imageStyle,
      children: imageNode
    }), title && /*#__PURE__*/_jsx("div", {
      className: cn("moly-result-title", styles.molyTitle, RESULT_STYLE.title[size]),
      children: title
    }), subTitle && /*#__PURE__*/_jsx("div", {
      className: cn("moly-result-subtitle", styles.molySubTitle, RESULT_STYLE.subTitle[size]),
      children: subTitle
    }), extra && /*#__PURE__*/_jsx("div", {
      className: cn('moly-result-extra', RESULT_STYLE.extra[size]),
      children: extra
    }), children && /*#__PURE__*/_jsx("div", {
      className: cn("moly-result-content"),
      children: children
    })]
  });
};
export default Result;